import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import ChartTable from "../chart-table";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const RepairedDefectiveStatus = ({ data }) => {
  if (!data || typeof data !== "object" || Object.keys(data).length === 0) {
    return <div>No data available</div>;
  }

  const labels = ["DEFECTIVE", "REPAIRED", "Grand Total"];

  // Filter out GrandTotal to build datasets dynamically
  const sources = Object.keys(data).filter((key) => key !== "GrandTotal");

  const datasets = sources.map((source, idx) => ({
    label: source,
    data: [
      data[source]?.DEFECTIVE ?? 0,
      data[source]?.REPAIRED ?? 0,
      data[source]?.total ?? 0,
    ],
    backgroundColor: getColor(idx),
    barThickness: 60,
  }));

  // Add Grand Total as a separate dataset
  if (data.GrandTotal) {
    datasets.push({
      label: "Grand Total",
      data: [
        data.GrandTotal?.DEFECTIVE ?? 0,
        data.GrandTotal?.REPAIRED ?? 0,
        data.GrandTotal?.total ?? 0,
      ],
      backgroundColor: "#2ecc71",
      barThickness: 60,
    });
  }

  const chartData = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      datalabels: {
        display: false,
      },
      datalabels: {
        color: "#ffffff",
        anchor: "center",
        align: "center",
        font: {
          weight: "bold",
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  const tableHeaders = ["", ...labels];
  const tableRows = [
    ...sources.map((source) => [
      source,
      data[source]?.DEFECTIVE ?? 0,
      data[source]?.REPAIRED ?? 0,
      data[source]?.total ?? 0,
    ]),
  ];

  if (data.GrandTotal) {
    tableRows.push([
      "Grand Total",
      data.GrandTotal.DEFECTIVE ?? 0,
      data.GrandTotal.REPAIRED ?? 0,
      data.GrandTotal.total ?? 0,
    ]);
  }

  return (
    <div>
      <Bar data={chartData} options={options} height={100} />
      <div style={{ marginTop: "24px" }}>
        <ChartTable headers={tableHeaders} rows={tableRows} />
      </div>
    </div>
  );
};

// Simple color generator from fixed palette
const getColor = (index) => {
  const colors = [
    "#3e95cd",
    "#e74c3c",
    "#9b59b6",
    "#f1c40f",
    "#1abc9c",
    "#34495e",
  ];
  return colors[index % colors.length];
};

export default RepairedDefectiveStatus;
